export default class Payment {
  amount: string;
  currency: string;
  name: string = "Gymbook";
  description: "Manage your gym anytime any where.";
  image?: string;
  prefill?: PaymentContact;
  notes: Notes;
  finalAmount: number;
}

export interface PaymentContact {
  name: string;
  email: string;
  contact: string;
}

export interface Notes {
  paymentId: string;
}
